import React from "react";
import styled from "styled-components";

const Responsive = () => {
  return (
    <Wrapper>
      <div className="super-container">
        <div className="zero-div-container">
           <div className='zero-item'>1</div>
           <div className='zero-item'>2</div>
           <div className='zero-item'>3</div>



        </div>
        <div className="first-div-container">
          <h1>Space</h1>
          <img src="https://www.shutterstock.com/image-illustration/astronaut-outer-space-flying-towards-260nw-1527070148.jpg" />
        </div>
        <div className="second-div-container">
          <div className="three-col-item">
            <h3>1</h3>
            <p>
              We’ll assume that you have some familiarity with HTML and
              JavaScript, but you should be able to follow along even if you’re
              coming from a different programming language. We’ll also assume
              that you’re familiar with programming concepts like functions,
              objects, arrays, and to a lesser extent, classes.
            </p>
          </div>

          <div className="three-col-item">
          <h3>2</h3>
            We’ll assume that you have some familiarity with HTML and
            JavaScript, but you should be able to follow along even if you’re
            coming from a different programming language. We’ll also assume that
            you’re familiar with programming concepts like functions, objects,
            arrays, and to a lesser extent, classes.We’ll assume that you have
            some familiarity with HTML and JavaScript, but you should be able to
            follow along even if you’re coming from a different programming
            language. We’ll also assume that you’re familiar with programming
            concepts like functions, objects, arrays, and to a lesser extent,
            classes.
          </div>
          <div className="three-col-item">
          <h3>3</h3>
            1We’ll assume that you have some familiarity with HTML and
            JavaScript, but you should be able to follow along even if you’re
            coming from a different programming language. We’ll also assume that
            you’re familiar with programming concepts like functions, objects,
            arrays, and to a lesser extent, classes.
          </div>
        </div>
        <div className="third-div-container">
          <div className="two-col-item common">1</div>
          <div className="two-col-item common">1</div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`

  .super-container {
/* text-align: center; */
/* margin-left: auto;
margin-right: auto; */



  }
  h1 {
    width: 90%;
    position: absolute;
    text-align: center;
  }
  img {
    width: 100%;
  }
  .zero-div-container{
    display: flex;
    justify-content: center;
    gap: 3.2rem;
    
  }
  .zero-main-cont{

  }
  .zero-item{
    width: 20rem;
    border: 1px solid black;
 
    background-color: red;


    /* justify-content: center; */
  }
  .first-div-container {
    /* background-color: aqua; */
    border: 1px solid black;
  }
  .second-div-container {
    border: 1px solid black;
    display: flex;
    justify-content: space-around;
  }
  .third-div-container {
    background-color: yellow;
    border: 1px solid black;
    display: flex;
  }
  .three-col-item {
    background-color: #bff3f5;
    width: 25%;
    border: 1px solid black;
    /* margin: 1rem; */
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
  .two-col-item {
    width: 75%;
    border: 1px solid black;
    margin: 1rem;
  }
  p {
    overflow: hidden;
    word-wrap: break-word;
  }
  .common {
    border: 1px solid black;
  }

  @media (max-width: 400px) {
    width: 100%;
    /* padding: 1rem; */
    .second-div-container{
      flex-direction: column;
    /* background-color: red; */
    }
    .three-col-item {
    background-color: #bff3f5;
    display: flex;

    width: 100%;
    /* margin: 1%; */
 
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
 
  }

`;

export default Responsive;
